import { createContext } from 'react';

import { noop } from '@altirllc/shared/utils/functionalUtils';

import type { TUser } from '@/types/profile';

export type TAuthContext = TAuthState & {
  updateProfile: (profile: TUser) => void;
  /**
   * Records that the partner now owns a station (set after the Add Station wizard created one),
   * so `hasStations` is not stale until the next sign-in. Does nothing when signed out.
   */
  markHasStations: () => void;
};

export type TAuthState =
  | {
      authenticated: false;
    }
  | {
      authenticated: true;
      profileComplete: boolean;
      hasStations: boolean;
      profile: TUser;
    };

export const AuthContext = createContext<TAuthContext>({
  authenticated: false,
  updateProfile: noop,
  markHasStations: noop,
});
